export const business = 'cocheseguro';
